import React from 'react';
import { X, Wifi } from 'lucide-react';

const VpnAssignDialog = ({ customer, pool, selectedPoolId, setSelectedPoolId, onConfirm, onClose, loading }) => {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="p-5 border-b flex justify-between items-center">
          <h3 className="font-bold text-gray-800 flex items-center gap-2">
            <Wifi className="w-5 h-5 text-blue-600" />分配 VPN 账号
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-sm text-gray-600">
            客户：<span className="font-medium">{customer.name || customer.username}</span>
          </p>
          {loading ? (
            <div className="text-center py-4">
              <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
            </div>
          ) : pool.length === 0 ? (
            <div className="text-center py-4 text-gray-400">
              <Wifi className="w-8 h-8 mx-auto mb-2 opacity-30" />
              <p className="text-sm">暂无可用账号，请先在 VPN 管理页面添加</p>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">选择账号</label>
              <select value={selectedPoolId} onChange={e => setSelectedPoolId(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500">
                <option value="">请选择</option>
                {pool.map(p => (
                  <option key={p.id} value={p.id}>
                    {p.account_name} {p.notes ? `(${p.notes})` : ''} {p.expired_ts ? `- 到期 ${new Date(p.expired_ts * 1000).toLocaleDateString()}` : ''}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div className="p-5 border-t flex gap-3">
          <button onClick={onClose}
            className="flex-1 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
            取消
          </button>
          <button onClick={onConfirm} disabled={loading || !selectedPoolId}
            className="flex-1 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
            {loading ? '处理中...' : '确认分配'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VpnAssignDialog;